const ENV = process.env.NODE_ENV;

const BASEURL_MAP = {
  development: '',
  beta: '',
  production: '',
};
export default BASEURL_MAP[ENV];



// WEBPACK FOOTER //
// ./src/utils/Request/config.js